import { useState } from 'react';

export const useCookieConsent = () => {
  const [consentState, setConsentState] = useState({
    analytics: false,
    marketing: false,
    necessary: true
  });

  return {
    consentState,
    setConsentState
  };
};
